export const FILE_STORAGE_QUERY_KEY = 'file-storage';
